<header class="app-header">
  <div class="header-left">
    <img class="logo" src="assets/images/svg/fagforbundet-logo-rgb.webp" alt="Logo" />
    <nav class="header-nav" aria-label="Hovednavigasjon">
      @if (hasEmployerAccess()) {
        <a class="header-link" routerLink="/" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }">
          <img src="assets/icons/dashboard-menu-boxes/document.svg" alt="" aria-hidden="true" class="header-link-icon" />
          Send trekkliste
        </a>
      }
      <a class="header-link" routerLink="/apply-employer" routerLinkActive="active">
        <img src="assets/icons/dashboard-menu-boxes/enlistment.svg" alt="" aria-hidden="true" class="header-link-icon" />
        Søk tilgang
      </a>
      @if (hasEmployerAccess()) {
        <a class="header-link" routerLink="/deduction-rates" routerLinkActive="active">
          <img src="assets/icons/dashboard-menu-boxes/Dues.svg" alt="" aria-hidden="true" class="header-link-icon" />
          Kontingentsatser
        </a>
      }
    </nav>
  </div>

  <div class="header-right">
    <a class="manual-link" routerLink="/brukermanual" title="Åpne brukermanual">
      <img src="assets/icons/dashboard-menu-boxes/Student color 48.png" alt="" aria-hidden="true" class="header-link-icon" />
      <span>Brukermanual</span>
    </a>

    <button type="button" mat-icon-button [matMenuTriggerFor]="beforeMenu" title="Åpne profil meny" class="avatar-btn">
      {{ getInitials(authService.fullName) }}
    </button>

    <mat-menu #beforeMenu="matMenu" class="ff-menu" xPosition="before">
      <div class="profile">
        <div class="initials-circle">
          {{ getInitials(authService.fullName) }}
        </div>
        <div class="profile-info">
          <div class="name">{{ authService.fullName }}</div>
        </div>
      </div>
      <hr (click)="$event.stopPropagation()" />
      <button type="button" class="ff-menu-item flex items-center gap-3 no-border-button" (click)="goToUserProfile()">
        <mat-icon class="material-icons-outlined">person</mat-icon>
        <div>Din profil</div>
      </button>
      <button type="button" class="ff-menu-item flex items-center gap-3 no-border-button">
        <mat-icon class="material-icons-outlined">cookie</mat-icon>
        <div>Håndter cookies</div>
      </button>
      <hr class="logout-separator" />
      <button type="button" class="ff-menu-item logout-item flex items-center gap-3 no-border-button" (click)="logout()">
        <mat-icon class="material-icons-outlined">logout</mat-icon>
        <div>Logg ut</div>
      </button>
    </mat-menu>
  </div>
</header>
